/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSuperAdminRouteRouteImport } from './routes/_app/_superAdmin/route'
import { Route as AppPartnersRouteRouteImport } from './routes/_app/_partners/route'
import { Route as AppPartnerRouteRouteImport } from './routes/_app/_partner/route'
import { Route as AppSuperAdminSurveyStudioRouteImport } from './routes/_app/_superAdmin/survey-studio'
import { Route as AppSuperAdminPartnerAdminsRouteImport } from './routes/_app/_superAdmin/partner-admins'
import { Route as AppSuperAdminFeatureFlagsRouteImport } from './routes/_app/_superAdmin/feature-flags'
import { Route as AppPartnerMyPartnerRouteImport } from './routes/_app/_partner/my-partner'
import { Route as AppPartnersPromoCodesRouteRouteImport } from './routes/_app/_partners/promo-codes/route'
import { Route as AppPartnersPromoCodesIndexRouteImport } from './routes/_app/_partners/promo-codes/index'
import { Route as AppSuperAdminDocsQuestYamlRouteImport } from './routes/_app/_superAdmin/docs/quest-yaml'
import { Route as AppSuperAdminDictionaryTaxesRouteImport } from './routes/_app/_superAdmin/dictionary/taxes'
import { Route as AppSuperAdminDictionaryTaxThresholdsRouteImport } from './routes/_app/_superAdmin/dictionary/tax-thresholds'
import { Route as AppSuperAdminDictionaryTaxStateBracketsRouteImport } from './routes/_app/_superAdmin/dictionary/tax-state-brackets'
import { Route as AppSuperAdminDictionaryTaxSocialSecurityLimitsRouteImport } from './routes/_app/_superAdmin/dictionary/tax-social-security-limits'
import { Route as AppSuperAdminDictionaryTaxFederalBracketsRouteImport } from './routes/_app/_superAdmin/dictionary/tax-federal-brackets'
import { Route as AppSuperAdminDictionaryTaxCapitalGainsBracketsRouteImport } from './routes/_app/_superAdmin/dictionary/tax-capital-gains-brackets'
import { Route as AppSuperAdminDictionaryStandardDeductionsRouteImport } from './routes/_app/_superAdmin/dictionary/standard-deductions'
import { Route as AppSuperAdminDictionaryRequiredDistributionsRouteImport } from './routes/_app/_superAdmin/dictionary/required-distributions'
import { Route as AppSuperAdminDictionaryRealEstateRatesRouteImport } from './routes/_app/_superAdmin/dictionary/real-estate-rates'
import { Route as AppSuperAdminDictionaryFinExperiencesRouteImport } from './routes/_app/_superAdmin/dictionary/fin-experiences'
import { Route as AppSuperAdminDictionaryFinCategoriesRouteImport } from './routes/_app/_superAdmin/dictionary/fin-categories'
import { Route as AppSuperAdminDictionaryFilingStatusesRouteImport } from './routes/_app/_superAdmin/dictionary/filing-statuses'
import { Route as AppPartnersPromoCodesPartnerIdRouteImport } from './routes/_app/_partners/promo-codes/$partnerId'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSuperAdminRouteRoute = AppSuperAdminRouteRouteImport.update({
  id: '/_superAdmin',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPartnersRouteRoute = AppPartnersRouteRouteImport.update({
  id: '/_partners',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPartnerRouteRoute = AppPartnerRouteRouteImport.update({
  id: '/_partner',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSuperAdminSurveyStudioRoute =
  AppSuperAdminSurveyStudioRouteImport.update({
    id: '/survey-studio',
    path: '/survey-studio',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminPartnerAdminsRoute =
  AppSuperAdminPartnerAdminsRouteImport.update({
    id: '/partner-admins',
    path: '/partner-admins',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminFeatureFlagsRoute =
  AppSuperAdminFeatureFlagsRouteImport.update({
    id: '/feature-flags',
    path: '/feature-flags',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppPartnerMyPartnerRoute = AppPartnerMyPartnerRouteImport.update({
  id: '/my-partner',
  path: '/my-partner',
  getParentRoute: () => AppPartnerRouteRoute,
} as any)
const AppPartnersPromoCodesRouteRoute =
  AppPartnersPromoCodesRouteRouteImport.update({
    id: '/promo-codes',
    path: '/promo-codes',
    getParentRoute: () => AppPartnersRouteRoute,
  } as any)
const AppPartnersPromoCodesIndexRoute =
  AppPartnersPromoCodesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPartnersPromoCodesRouteRoute,
  } as any)
const AppSuperAdminDocsQuestYamlRoute =
  AppSuperAdminDocsQuestYamlRouteImport.update({
    id: '/docs/quest-yaml',
    path: '/docs/quest-yaml',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminDictionaryTaxesRoute =
  AppSuperAdminDictionaryTaxesRouteImport.update({
    id: '/dictionary/taxes',
    path: '/dictionary/taxes',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminDictionaryTaxThresholdsRoute =
  AppSuperAdminDictionaryTaxThresholdsRouteImport.update({
    id: '/dictionary/tax-thresholds',
    path: '/dictionary/tax-thresholds',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminDictionaryTaxStateBracketsRoute =
  AppSuperAdminDictionaryTaxStateBracketsRouteImport.update({
    id: '/dictionary/tax-state-brackets',
    path: '/dictionary/tax-state-brackets',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminDictionaryTaxSocialSecurityLimitsRoute =
  AppSuperAdminDictionaryTaxSocialSecurityLimitsRouteImport.update({
    id: '/dictionary/tax-social-security-limits',
    path: '/dictionary/tax-social-security-limits',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminDictionaryTaxFederalBracketsRoute =
  AppSuperAdminDictionaryTaxFederalBracketsRouteImport.update({
    id: '/dictionary/tax-federal-brackets',
    path: '/dictionary/tax-federal-brackets',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminDictionaryTaxCapitalGainsBracketsRoute =
  AppSuperAdminDictionaryTaxCapitalGainsBracketsRouteImport.update({
    id: '/dictionary/tax-capital-gains-brackets',
    path: '/dictionary/tax-capital-gains-brackets',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminDictionaryStandardDeductionsRoute =
  AppSuperAdminDictionaryStandardDeductionsRouteImport.update({
    id: '/dictionary/standard-deductions',
    path: '/dictionary/standard-deductions',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminDictionaryRequiredDistributionsRoute =
  AppSuperAdminDictionaryRequiredDistributionsRouteImport.update({
    id: '/dictionary/required-distributions',
    path: '/dictionary/required-distributions',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminDictionaryRealEstateRatesRoute =
  AppSuperAdminDictionaryRealEstateRatesRouteImport.update({
    id: '/dictionary/real-estate-rates',
    path: '/dictionary/real-estate-rates',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminDictionaryFinExperiencesRoute =
  AppSuperAdminDictionaryFinExperiencesRouteImport.update({
    id: '/dictionary/fin-experiences',
    path: '/dictionary/fin-experiences',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminDictionaryFinCategoriesRoute =
  AppSuperAdminDictionaryFinCategoriesRouteImport.update({
    id: '/dictionary/fin-categories',
    path: '/dictionary/fin-categories',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppSuperAdminDictionaryFilingStatusesRoute =
  AppSuperAdminDictionaryFilingStatusesRouteImport.update({
    id: '/dictionary/filing-statuses',
    path: '/dictionary/filing-statuses',
    getParentRoute: () => AppSuperAdminRouteRoute,
  } as any)
const AppPartnersPromoCodesPartnerIdRoute =
  AppPartnersPromoCodesPartnerIdRouteImport.update({
    id: '/$partnerId',
    path: '/$partnerId',
    getParentRoute: () => AppPartnersPromoCodesRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/promo-codes': typeof AppPartnersPromoCodesRouteRouteWithChildren
  '/my-partner': typeof AppPartnerMyPartnerRoute
  '/feature-flags': typeof AppSuperAdminFeatureFlagsRoute
  '/partner-admins': typeof AppSuperAdminPartnerAdminsRoute
  '/survey-studio': typeof AppSuperAdminSurveyStudioRoute
  '/promo-codes/$partnerId': typeof AppPartnersPromoCodesPartnerIdRoute
  '/dictionary/filing-statuses': typeof AppSuperAdminDictionaryFilingStatusesRoute
  '/dictionary/fin-categories': typeof AppSuperAdminDictionaryFinCategoriesRoute
  '/dictionary/fin-experiences': typeof AppSuperAdminDictionaryFinExperiencesRoute
  '/dictionary/real-estate-rates': typeof AppSuperAdminDictionaryRealEstateRatesRoute
  '/dictionary/required-distributions': typeof AppSuperAdminDictionaryRequiredDistributionsRoute
  '/dictionary/standard-deductions': typeof AppSuperAdminDictionaryStandardDeductionsRoute
  '/dictionary/tax-capital-gains-brackets': typeof AppSuperAdminDictionaryTaxCapitalGainsBracketsRoute
  '/dictionary/tax-federal-brackets': typeof AppSuperAdminDictionaryTaxFederalBracketsRoute
  '/dictionary/tax-social-security-limits': typeof AppSuperAdminDictionaryTaxSocialSecurityLimitsRoute
  '/dictionary/tax-state-brackets': typeof AppSuperAdminDictionaryTaxStateBracketsRoute
  '/dictionary/tax-thresholds': typeof AppSuperAdminDictionaryTaxThresholdsRoute
  '/dictionary/taxes': typeof AppSuperAdminDictionaryTaxesRoute
  '/docs/quest-yaml': typeof AppSuperAdminDocsQuestYamlRoute
  '/promo-codes/': typeof AppPartnersPromoCodesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/my-partner': typeof AppPartnerMyPartnerRoute
  '/feature-flags': typeof AppSuperAdminFeatureFlagsRoute
  '/partner-admins': typeof AppSuperAdminPartnerAdminsRoute
  '/survey-studio': typeof AppSuperAdminSurveyStudioRoute
  '/promo-codes/$partnerId': typeof AppPartnersPromoCodesPartnerIdRoute
  '/dictionary/filing-statuses': typeof AppSuperAdminDictionaryFilingStatusesRoute
  '/dictionary/fin-categories': typeof AppSuperAdminDictionaryFinCategoriesRoute
  '/dictionary/fin-experiences': typeof AppSuperAdminDictionaryFinExperiencesRoute
  '/dictionary/real-estate-rates': typeof AppSuperAdminDictionaryRealEstateRatesRoute
  '/dictionary/required-distributions': typeof AppSuperAdminDictionaryRequiredDistributionsRoute
  '/dictionary/standard-deductions': typeof AppSuperAdminDictionaryStandardDeductionsRoute
  '/dictionary/tax-capital-gains-brackets': typeof AppSuperAdminDictionaryTaxCapitalGainsBracketsRoute
  '/dictionary/tax-federal-brackets': typeof AppSuperAdminDictionaryTaxFederalBracketsRoute
  '/dictionary/tax-social-security-limits': typeof AppSuperAdminDictionaryTaxSocialSecurityLimitsRoute
  '/dictionary/tax-state-brackets': typeof AppSuperAdminDictionaryTaxStateBracketsRoute
  '/dictionary/tax-thresholds': typeof AppSuperAdminDictionaryTaxThresholdsRoute
  '/dictionary/taxes': typeof AppSuperAdminDictionaryTaxesRoute
  '/docs/quest-yaml': typeof AppSuperAdminDocsQuestYamlRoute
  '/promo-codes': typeof AppPartnersPromoCodesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_app/_partner': typeof AppPartnerRouteRouteWithChildren
  '/_app/_partners': typeof AppPartnersRouteRouteWithChildren
  '/_app/_superAdmin': typeof AppSuperAdminRouteRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/_partners/promo-codes': typeof AppPartnersPromoCodesRouteRouteWithChildren
  '/_app/_partner/my-partner': typeof AppPartnerMyPartnerRoute
  '/_app/_superAdmin/feature-flags': typeof AppSuperAdminFeatureFlagsRoute
  '/_app/_superAdmin/partner-admins': typeof AppSuperAdminPartnerAdminsRoute
  '/_app/_superAdmin/survey-studio': typeof AppSuperAdminSurveyStudioRoute
  '/_app/_partners/promo-codes/$partnerId': typeof AppPartnersPromoCodesPartnerIdRoute
  '/_app/_superAdmin/dictionary/filing-statuses': typeof AppSuperAdminDictionaryFilingStatusesRoute
  '/_app/_superAdmin/dictionary/fin-categories': typeof AppSuperAdminDictionaryFinCategoriesRoute
  '/_app/_superAdmin/dictionary/fin-experiences': typeof AppSuperAdminDictionaryFinExperiencesRoute
  '/_app/_superAdmin/dictionary/real-estate-rates': typeof AppSuperAdminDictionaryRealEstateRatesRoute
  '/_app/_superAdmin/dictionary/required-distributions': typeof AppSuperAdminDictionaryRequiredDistributionsRoute
  '/_app/_superAdmin/dictionary/standard-deductions': typeof AppSuperAdminDictionaryStandardDeductionsRoute
  '/_app/_superAdmin/dictionary/tax-capital-gains-brackets': typeof AppSuperAdminDictionaryTaxCapitalGainsBracketsRoute
  '/_app/_superAdmin/dictionary/tax-federal-brackets': typeof AppSuperAdminDictionaryTaxFederalBracketsRoute
  '/_app/_superAdmin/dictionary/tax-social-security-limits': typeof AppSuperAdminDictionaryTaxSocialSecurityLimitsRoute
  '/_app/_superAdmin/dictionary/tax-state-brackets': typeof AppSuperAdminDictionaryTaxStateBracketsRoute
  '/_app/_superAdmin/dictionary/tax-thresholds': typeof AppSuperAdminDictionaryTaxThresholdsRoute
  '/_app/_superAdmin/dictionary/taxes': typeof AppSuperAdminDictionaryTaxesRoute
  '/_app/_superAdmin/docs/quest-yaml': typeof AppSuperAdminDocsQuestYamlRoute
  '/_app/_partners/promo-codes/': typeof AppPartnersPromoCodesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/promo-codes'
    | '/my-partner'
    | '/feature-flags'
    | '/partner-admins'
    | '/survey-studio'
    | '/promo-codes/$partnerId'
    | '/dictionary/filing-statuses'
    | '/dictionary/fin-categories'
    | '/dictionary/fin-experiences'
    | '/dictionary/real-estate-rates'
    | '/dictionary/required-distributions'
    | '/dictionary/standard-deductions'
    | '/dictionary/tax-capital-gains-brackets'
    | '/dictionary/tax-federal-brackets'
    | '/dictionary/tax-social-security-limits'
    | '/dictionary/tax-state-brackets'
    | '/dictionary/tax-thresholds'
    | '/dictionary/taxes'
    | '/docs/quest-yaml'
    | '/promo-codes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/my-partner'
    | '/feature-flags'
    | '/partner-admins'
    | '/survey-studio'
    | '/promo-codes/$partnerId'
    | '/dictionary/filing-statuses'
    | '/dictionary/fin-categories'
    | '/dictionary/fin-experiences'
    | '/dictionary/real-estate-rates'
    | '/dictionary/required-distributions'
    | '/dictionary/standard-deductions'
    | '/dictionary/tax-capital-gains-brackets'
    | '/dictionary/tax-federal-brackets'
    | '/dictionary/tax-social-security-limits'
    | '/dictionary/tax-state-brackets'
    | '/dictionary/tax-thresholds'
    | '/dictionary/taxes'
    | '/docs/quest-yaml'
    | '/promo-codes'
  id:
    | '__root__'
    | '/_app'
    | '/_app/_partner'
    | '/_app/_partners'
    | '/_app/_superAdmin'
    | '/_app/'
    | '/_app/_partners/promo-codes'
    | '/_app/_partner/my-partner'
    | '/_app/_superAdmin/feature-flags'
    | '/_app/_superAdmin/partner-admins'
    | '/_app/_superAdmin/survey-studio'
    | '/_app/_partners/promo-codes/$partnerId'
    | '/_app/_superAdmin/dictionary/filing-statuses'
    | '/_app/_superAdmin/dictionary/fin-categories'
    | '/_app/_superAdmin/dictionary/fin-experiences'
    | '/_app/_superAdmin/dictionary/real-estate-rates'
    | '/_app/_superAdmin/dictionary/required-distributions'
    | '/_app/_superAdmin/dictionary/standard-deductions'
    | '/_app/_superAdmin/dictionary/tax-capital-gains-brackets'
    | '/_app/_superAdmin/dictionary/tax-federal-brackets'
    | '/_app/_superAdmin/dictionary/tax-social-security-limits'
    | '/_app/_superAdmin/dictionary/tax-state-brackets'
    | '/_app/_superAdmin/dictionary/tax-thresholds'
    | '/_app/_superAdmin/dictionary/taxes'
    | '/_app/_superAdmin/docs/quest-yaml'
    | '/_app/_partners/promo-codes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/_superAdmin': {
      id: '/_app/_superAdmin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppSuperAdminRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/_partners': {
      id: '/_app/_partners'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppPartnersRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/_partner': {
      id: '/_app/_partner'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppPartnerRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/_superAdmin/survey-studio': {
      id: '/_app/_superAdmin/survey-studio'
      path: '/survey-studio'
      fullPath: '/survey-studio'
      preLoaderRoute: typeof AppSuperAdminSurveyStudioRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/partner-admins': {
      id: '/_app/_superAdmin/partner-admins'
      path: '/partner-admins'
      fullPath: '/partner-admins'
      preLoaderRoute: typeof AppSuperAdminPartnerAdminsRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/feature-flags': {
      id: '/_app/_superAdmin/feature-flags'
      path: '/feature-flags'
      fullPath: '/feature-flags'
      preLoaderRoute: typeof AppSuperAdminFeatureFlagsRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_partner/my-partner': {
      id: '/_app/_partner/my-partner'
      path: '/my-partner'
      fullPath: '/my-partner'
      preLoaderRoute: typeof AppPartnerMyPartnerRouteImport
      parentRoute: typeof AppPartnerRouteRoute
    }
    '/_app/_partners/promo-codes': {
      id: '/_app/_partners/promo-codes'
      path: '/promo-codes'
      fullPath: '/promo-codes'
      preLoaderRoute: typeof AppPartnersPromoCodesRouteRouteImport
      parentRoute: typeof AppPartnersRouteRoute
    }
    '/_app/_partners/promo-codes/': {
      id: '/_app/_partners/promo-codes/'
      path: '/'
      fullPath: '/promo-codes/'
      preLoaderRoute: typeof AppPartnersPromoCodesIndexRouteImport
      parentRoute: typeof AppPartnersPromoCodesRouteRoute
    }
    '/_app/_superAdmin/docs/quest-yaml': {
      id: '/_app/_superAdmin/docs/quest-yaml'
      path: '/docs/quest-yaml'
      fullPath: '/docs/quest-yaml'
      preLoaderRoute: typeof AppSuperAdminDocsQuestYamlRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/dictionary/taxes': {
      id: '/_app/_superAdmin/dictionary/taxes'
      path: '/dictionary/taxes'
      fullPath: '/dictionary/taxes'
      preLoaderRoute: typeof AppSuperAdminDictionaryTaxesRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/dictionary/tax-thresholds': {
      id: '/_app/_superAdmin/dictionary/tax-thresholds'
      path: '/dictionary/tax-thresholds'
      fullPath: '/dictionary/tax-thresholds'
      preLoaderRoute: typeof AppSuperAdminDictionaryTaxThresholdsRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/dictionary/tax-state-brackets': {
      id: '/_app/_superAdmin/dictionary/tax-state-brackets'
      path: '/dictionary/tax-state-brackets'
      fullPath: '/dictionary/tax-state-brackets'
      preLoaderRoute: typeof AppSuperAdminDictionaryTaxStateBracketsRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/dictionary/tax-social-security-limits': {
      id: '/_app/_superAdmin/dictionary/tax-social-security-limits'
      path: '/dictionary/tax-social-security-limits'
      fullPath: '/dictionary/tax-social-security-limits'
      preLoaderRoute: typeof AppSuperAdminDictionaryTaxSocialSecurityLimitsRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/dictionary/tax-federal-brackets': {
      id: '/_app/_superAdmin/dictionary/tax-federal-brackets'
      path: '/dictionary/tax-federal-brackets'
      fullPath: '/dictionary/tax-federal-brackets'
      preLoaderRoute: typeof AppSuperAdminDictionaryTaxFederalBracketsRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/dictionary/tax-capital-gains-brackets': {
      id: '/_app/_superAdmin/dictionary/tax-capital-gains-brackets'
      path: '/dictionary/tax-capital-gains-brackets'
      fullPath: '/dictionary/tax-capital-gains-brackets'
      preLoaderRoute: typeof AppSuperAdminDictionaryTaxCapitalGainsBracketsRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/dictionary/standard-deductions': {
      id: '/_app/_superAdmin/dictionary/standard-deductions'
      path: '/dictionary/standard-deductions'
      fullPath: '/dictionary/standard-deductions'
      preLoaderRoute: typeof AppSuperAdminDictionaryStandardDeductionsRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/dictionary/required-distributions': {
      id: '/_app/_superAdmin/dictionary/required-distributions'
      path: '/dictionary/required-distributions'
      fullPath: '/dictionary/required-distributions'
      preLoaderRoute: typeof AppSuperAdminDictionaryRequiredDistributionsRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/dictionary/real-estate-rates': {
      id: '/_app/_superAdmin/dictionary/real-estate-rates'
      path: '/dictionary/real-estate-rates'
      fullPath: '/dictionary/real-estate-rates'
      preLoaderRoute: typeof AppSuperAdminDictionaryRealEstateRatesRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/dictionary/fin-experiences': {
      id: '/_app/_superAdmin/dictionary/fin-experiences'
      path: '/dictionary/fin-experiences'
      fullPath: '/dictionary/fin-experiences'
      preLoaderRoute: typeof AppSuperAdminDictionaryFinExperiencesRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/dictionary/fin-categories': {
      id: '/_app/_superAdmin/dictionary/fin-categories'
      path: '/dictionary/fin-categories'
      fullPath: '/dictionary/fin-categories'
      preLoaderRoute: typeof AppSuperAdminDictionaryFinCategoriesRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_superAdmin/dictionary/filing-statuses': {
      id: '/_app/_superAdmin/dictionary/filing-statuses'
      path: '/dictionary/filing-statuses'
      fullPath: '/dictionary/filing-statuses'
      preLoaderRoute: typeof AppSuperAdminDictionaryFilingStatusesRouteImport
      parentRoute: typeof AppSuperAdminRouteRoute
    }
    '/_app/_partners/promo-codes/$partnerId': {
      id: '/_app/_partners/promo-codes/$partnerId'
      path: '/$partnerId'
      fullPath: '/promo-codes/$partnerId'
      preLoaderRoute: typeof AppPartnersPromoCodesPartnerIdRouteImport
      parentRoute: typeof AppPartnersPromoCodesRouteRoute
    }
  }
}

interface AppPartnerRouteRouteChildren {
  AppPartnerMyPartnerRoute: typeof AppPartnerMyPartnerRoute
}

const AppPartnerRouteRouteChildren: AppPartnerRouteRouteChildren = {
  AppPartnerMyPartnerRoute: AppPartnerMyPartnerRoute,
}

const AppPartnerRouteRouteWithChildren = AppPartnerRouteRoute._addFileChildren(
  AppPartnerRouteRouteChildren,
)

interface AppPartnersPromoCodesRouteRouteChildren {
  AppPartnersPromoCodesPartnerIdRoute: typeof AppPartnersPromoCodesPartnerIdRoute
  AppPartnersPromoCodesIndexRoute: typeof AppPartnersPromoCodesIndexRoute
}

const AppPartnersPromoCodesRouteRouteChildren: AppPartnersPromoCodesRouteRouteChildren =
  {
    AppPartnersPromoCodesPartnerIdRoute: AppPartnersPromoCodesPartnerIdRoute,
    AppPartnersPromoCodesIndexRoute: AppPartnersPromoCodesIndexRoute,
  }

const AppPartnersPromoCodesRouteRouteWithChildren =
  AppPartnersPromoCodesRouteRoute._addFileChildren(
    AppPartnersPromoCodesRouteRouteChildren,
  )

interface AppPartnersRouteRouteChildren {
  AppPartnersPromoCodesRouteRoute: typeof AppPartnersPromoCodesRouteRouteWithChildren
}

const AppPartnersRouteRouteChildren: AppPartnersRouteRouteChildren = {
  AppPartnersPromoCodesRouteRoute: AppPartnersPromoCodesRouteRouteWithChildren,
}

const AppPartnersRouteRouteWithChildren =
  AppPartnersRouteRoute._addFileChildren(AppPartnersRouteRouteChildren)

interface AppSuperAdminRouteRouteChildren {
  AppSuperAdminFeatureFlagsRoute: typeof AppSuperAdminFeatureFlagsRoute
  AppSuperAdminPartnerAdminsRoute: typeof AppSuperAdminPartnerAdminsRoute
  AppSuperAdminSurveyStudioRoute: typeof AppSuperAdminSurveyStudioRoute
  AppSuperAdminDictionaryFilingStatusesRoute: typeof AppSuperAdminDictionaryFilingStatusesRoute
  AppSuperAdminDictionaryFinCategoriesRoute: typeof AppSuperAdminDictionaryFinCategoriesRoute
  AppSuperAdminDictionaryFinExperiencesRoute: typeof AppSuperAdminDictionaryFinExperiencesRoute
  AppSuperAdminDictionaryRealEstateRatesRoute: typeof AppSuperAdminDictionaryRealEstateRatesRoute
  AppSuperAdminDictionaryRequiredDistributionsRoute: typeof AppSuperAdminDictionaryRequiredDistributionsRoute
  AppSuperAdminDictionaryStandardDeductionsRoute: typeof AppSuperAdminDictionaryStandardDeductionsRoute
  AppSuperAdminDictionaryTaxCapitalGainsBracketsRoute: typeof AppSuperAdminDictionaryTaxCapitalGainsBracketsRoute
  AppSuperAdminDictionaryTaxFederalBracketsRoute: typeof AppSuperAdminDictionaryTaxFederalBracketsRoute
  AppSuperAdminDictionaryTaxSocialSecurityLimitsRoute: typeof AppSuperAdminDictionaryTaxSocialSecurityLimitsRoute
  AppSuperAdminDictionaryTaxStateBracketsRoute: typeof AppSuperAdminDictionaryTaxStateBracketsRoute
  AppSuperAdminDictionaryTaxThresholdsRoute: typeof AppSuperAdminDictionaryTaxThresholdsRoute
  AppSuperAdminDictionaryTaxesRoute: typeof AppSuperAdminDictionaryTaxesRoute
  AppSuperAdminDocsQuestYamlRoute: typeof AppSuperAdminDocsQuestYamlRoute
}

const AppSuperAdminRouteRouteChildren: AppSuperAdminRouteRouteChildren = {
  AppSuperAdminFeatureFlagsRoute: AppSuperAdminFeatureFlagsRoute,
  AppSuperAdminPartnerAdminsRoute: AppSuperAdminPartnerAdminsRoute,
  AppSuperAdminSurveyStudioRoute: AppSuperAdminSurveyStudioRoute,
  AppSuperAdminDictionaryFilingStatusesRoute:
    AppSuperAdminDictionaryFilingStatusesRoute,
  AppSuperAdminDictionaryFinCategoriesRoute:
    AppSuperAdminDictionaryFinCategoriesRoute,
  AppSuperAdminDictionaryFinExperiencesRoute:
    AppSuperAdminDictionaryFinExperiencesRoute,
  AppSuperAdminDictionaryRealEstateRatesRoute:
    AppSuperAdminDictionaryRealEstateRatesRoute,
  AppSuperAdminDictionaryRequiredDistributionsRoute:
    AppSuperAdminDictionaryRequiredDistributionsRoute,
  AppSuperAdminDictionaryStandardDeductionsRoute:
    AppSuperAdminDictionaryStandardDeductionsRoute,
  AppSuperAdminDictionaryTaxCapitalGainsBracketsRoute:
    AppSuperAdminDictionaryTaxCapitalGainsBracketsRoute,
  AppSuperAdminDictionaryTaxFederalBracketsRoute:
    AppSuperAdminDictionaryTaxFederalBracketsRoute,
  AppSuperAdminDictionaryTaxSocialSecurityLimitsRoute:
    AppSuperAdminDictionaryTaxSocialSecurityLimitsRoute,
  AppSuperAdminDictionaryTaxStateBracketsRoute:
    AppSuperAdminDictionaryTaxStateBracketsRoute,
  AppSuperAdminDictionaryTaxThresholdsRoute:
    AppSuperAdminDictionaryTaxThresholdsRoute,
  AppSuperAdminDictionaryTaxesRoute: AppSuperAdminDictionaryTaxesRoute,
  AppSuperAdminDocsQuestYamlRoute: AppSuperAdminDocsQuestYamlRoute,
}

const AppSuperAdminRouteRouteWithChildren =
  AppSuperAdminRouteRoute._addFileChildren(AppSuperAdminRouteRouteChildren)

interface AppRouteRouteChildren {
  AppPartnerRouteRoute: typeof AppPartnerRouteRouteWithChildren
  AppPartnersRouteRoute: typeof AppPartnersRouteRouteWithChildren
  AppSuperAdminRouteRoute: typeof AppSuperAdminRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppPartnerRouteRoute: AppPartnerRouteRouteWithChildren,
  AppPartnersRouteRoute: AppPartnersRouteRouteWithChildren,
  AppSuperAdminRouteRoute: AppSuperAdminRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
